import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_e4kpbeuvwn: FaireBrandEntity = {
  token: "b_e4kpbeuvwn",
  type: "brand",
  name: "T Marie",
  avatarUrl:
    "https://cdn.faire.com/fastly/0b95bd56d512e71d61730d2d399d0f2a1688b0ca8423c84127b9275105421476.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7c79e713f3c829ce3fae5dff63c6050a45d7fa64a61e3421192b739944712928.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/0b95bd56d512e71d61730d2d399d0f2a1688b0ca8423c84127b9275105421476.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7c79e713f3c829ce3fae5dff63c6050a45d7fa64a61e3421192b739944712928.jpeg",
  location: "Vancouver, BC, CAN",
  minimumOrderDollars: 50,
  rating: 4.9,
  reviewCount: 12,
  isInsider: true,
  description:
    "At T Marie, we value the time-honored tradition of stationery, from writing special notes of love and kindness, to celebrating life’s big and small moments. This is why we design fine quality stationery - heartfelt cards you can be proud to give to anyone, and office supplies that will bring joy and improve your work.\n\nEach of our products are lovingly designed by our team of artists, and our stationery practically shines with love and care. Whenever you send a card, plan your day or grow your business, we hope that T Marie can add a little bit of sparkle to your day!",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:33.487Z",
    importedBy: "entity-db-cli",
  },
};
